<template>
  <section class="info-producto" v-if="producto.id" :style="estiloEvento">
    <share-button />
    <!-- 📸 IMAGEN + BOTÓN COMPARTIR -->
    <div class="foto-principal-container" @click="abrirImagenModal">
      <b-carousel
        :autoplay="fotosProducto.length > 1"
        :interval="2500"
        :has-indicators="fotosProducto.length > 1"
        :indicator-style="`background-color: ${colorContraste(eventoColor)};`"
      >
        <b-carousel-item
          v-for="foto in fotosProducto"
          :key="foto.id"
          class="carousel-item-foto"
        >
          <img :src="foto.url" :alt="producto.nombre" />
        </b-carousel-item>
      </b-carousel>

      <!-- ⚡ DEGRADADO -->
      <div class="degradado"></div>

      <!-- 🧾 NOMBRE + BADGES -->
      <div class="overlay-info">
        <div class="nombre-wrapper">
          <h1 class="nombre-producto">{{ producto.nombre }}</h1>
        </div>
        <div class="badges">
          <!-- Nombre restaurante con icono verificado y redirección -->
          <span class="badge restaurante-verificado" @click="irARestaurante">
            {{ restaurante.nombre }}
            <b-icon icon="check-circle" class="icono-verificado" />
          </span>

          <!-- BADGES REDES -->
          <span
            class="badge icono"
            v-if="restaurante.instagram"
            @click.stop="abrirInstagram"
          >
            <b-icon icon="instagram" />
          </span>

          <span
            class="badge icono"
            v-if="restaurante.facebook"
            @click.stop="abrirFacebook"
          >
            <b-icon icon="facebook" />
          </span>
        </div>
      </div>

      <!-- 📤 BOTÓN COMPARTIR BONITO -->
      <button class="boton-compartir" @click.stop="compartirProducto">
        <b-icon icon="send" />
      </button>
    </div>

    <!-- 📝 INFO DETALLADA -->
    <div class="p-4">
      <p class="mb-4" v-if="producto.descripcion">{{ producto.descripcion }}</p>

      <!-- 📍 INFORMACIÓN RESTAURANTE -->
      <div v-if="restaurante.id">
        <h3 class="sede-titulo">Sede 1</h3>
        <ul class="info">
          <li><b-icon icon="city" /> {{ restaurante.ciudad }}</li>
          <li
            class="info-link"
            @click="abrirEnMapa(restaurante.direccion, restaurante.ciudad)"
          >
            <b-icon icon="map-marker" class="icono-info" />
            <span class="texto-link">{{ restaurante.direccion }}</span>
            <b-icon icon="chevron-right" class="flecha" />
          </li>

          <li class="info-link">
            <b-icon icon="whatsapp" class="icono-info-Whatsapp" />
            <a
              :href="'https://wa.me/' + restaurante.telefono"
              target="_blank"
              class="texto-link"
            >
              {{ restaurante.telefono }}
            </a>
          </li>
        </ul>

        <div
          v-if="
            restaurante.direccion2 ||
            restaurante.telefono2 ||
            restaurante.ciudad2
          "
        >
          <h3 class="sede-titulo">Sede 2</h3>
          <ul class="info">
            <li><b-icon icon="city" /> {{ restaurante.ciudad2 }}</li>
            <li
              class="info-link"
              @click="abrirEnMapa(restaurante.direccion2, restaurante.ciudad2)"
            >
              <b-icon icon="map-marker" class="icono-info" />
              <span class="texto-link">{{ restaurante.direccion2 }}</span>
              <b-icon icon="chevron-right" class="flecha" />
            </li>

            <li class="info-link">
              <b-icon icon="whatsapp" class="icono-info-Whatsapp" />
              <a
                :href="'https://wa.me/' + restaurante.telefono2"
                target="_blank"
                class="texto-link"
              >
                {{ restaurante.telefono2 }}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- ⭐ CALIFICACIÓN -->
      <div class="box mt-5">
        <template v-if="!mostrarCalificacion">
          <b-button :style="botonCalificarEstilo" @click="intentCalificar">
            Calificar
          </b-button>
        </template>
        <template v-else>
          <template v-if="!existeCalificacion">
            <b-field label="Calificación">
              <div
                class="swal2-rating"
                style="display: flex; justify-content: center; gap: 3px"
              >
                <span
                  v-for="star in 5"
                  :key="star"
                  class="star"
                  :data-value="star"
                  :style="{
                    fontSize: '22px',
                    cursor: 'pointer',
                    color:
                      star <= nuevaCalificacion.calificacion ? 'gold' : 'gray',
                  }"
                  @click="setCalificacion(star)"
                >
                  ★
                </span>
              </div>
            </b-field>
            <b-field label="Observaciones">
              <b-input
                v-model="nuevaCalificacion.observaciones"
                type="textarea"
                maxlength="255"
              />
            </b-field>
            <b-button
              :style="botonCalificarEstilo"
              :disabled="!nuevaCalificacion.calificacion"
              @click="enviarCalificacion"
            >
              Enviar calificación
            </b-button>
          </template>
          <template v-else>
            <b-field label="Calificación">
              <b-rate
                :value="nuevaCalificacion.calificacion"
                :max="5"
                disabled
              />
            </b-field>
            <b-field
              label="Observaciones"
              v-if="nuevaCalificacion.observaciones"
            >
              <p>{{ nuevaCalificacion.observaciones }}</p>
            </b-field>
            <p>Ya calificaste este producto.</p>
          </template>
        </template>
      </div>

    </div>

    <div v-if="mostrarZoom" class="zoom-overlay">
      <button class="cerrar" @click="mostrarZoom = false">✕</button>
      <div class="zoom-container">
        <img
          :src="fotoPrincipal"
          ref="zoomImagen"
          class="zoom-img"
          @wheel="hacerZoom"
        />
      </div>
    </div>

    <b-loading :is-full-page="true" v-model="cargando" :can-cancel="false" />
    <b-modal
      :active.sync="modalImagen"
      :full-screen="true"
      :can-cancel="true"
      class="modal-imagen"
    >
      <img
        :src="imagenActual"
        :class="{ zoom: zoomActivo }"
        @click="toggleZoom"
      />
    </b-modal>
  </section>
</template>

<script>
import HttpService from "../../Servicios/HttpService";
import { ColorContrasteMixin } from "../mixins/ColorContrasteMixin";
import ShareButton from "../ShareButton.vue";
import Swal from "sweetalert2";
import {
  existeRegistroParaRestaurante,
  guardarDatosSesion,
  obtenerDatosSesion,
  registrarSesionEnTabla,
} from "@/utils/sesionCalificacion";

export default {
  name: "InfoProducto",
  components: { ShareButton },
  mixins: [ColorContrasteMixin],
  data() {
    return {
      producto: {},
      restaurante: {},
      fotoPrincipal: "",
      fotosProducto: [],
      cargando: false,
      modalImagen: false,
      imagenActual: "",
      zoomActivo: false,
      idUsuario: null,
      mostrarCalificacion: false,
      nuevaCalificacion: {
        idProducto: null,
        idRestaurante: null,
        idParticipante: null,
        calificacion: 0,
        observaciones: "",
      },
      existeCalificacion: false,
      eventoColor: "#3273dc", // Color por defecto
      mostrarZoom: false,
      escala: 1,
    };
  },
  mounted() {
    const id = this.$route.params.id;
    this.obtenerDatos(id);
    this.obtenerColorEvento();

    const datos = obtenerDatosSesion();
    if (datos?.telefono) {
      this.idUsuario = datos.telefono;
      this.nuevaCalificacion.idParticipante = datos.telefono;

      setTimeout(() => {
        this.verificarCalificacion();
      }, 950);
    }
  },
  methods: {
    toggleZoom() {
      this.zoomActivo = !this.zoomActivo;
      if (this.zoomActivo) {
        this.imagenActual = this.fotoPrincipal;
        this.$nextTick(() => {
          this.$refs.zoomImagen.style.transform = "scale(1.5)";
        });
      } else {
        this.$refs.zoomImagen.style.transform = "scale(1)";
      }
    },
    hacerZoom(e) {
      e.preventDefault();
      this.escala += e.deltaY * -0.001;
      this.escala = Math.min(Math.max(1, this.escala), 4);
      this.$refs.zoomImagen.style.transform = `scale(${this.escala})`;
    },
    irARestaurante() {
      this.$router.push(`/restaurante/${this.restaurante.id}`);
    },
    abrirInstagram() {
      window.open(this.restaurante.instagram, "_blank", "noopener");
    },
    abrirFacebook() {
      window.open(this.restaurante.facebook, "_blank", "noopener");
    },
    abrirImagenModal() {
      this.mostrarZoom = true;
    },
    abrirEnMapa(dir, ciudad) {
      const direccionCompleta = ciudad ? `${dir}, ${ciudad}` : dir;
      const query = encodeURIComponent(direccionCompleta);
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
      const url = isIOS
        ? `http://maps.apple.com/?q=${query}`
        : `https://www.google.com/maps/search/?api=1&query=${query}`;
      window.open(url, "_blank");
    },
    setCalificacion(valor) {
      this.nuevaCalificacion.calificacion = valor;
    },
    async obtenerDatos(id) {
      this.cargando = true;
      const [prods, rests, fotos] = await Promise.all([
        HttpService.registrar("productos.php", { accion: "obtener" }),
        HttpService.registrar("restaurantes.php", { accion: "obtener" }),
        HttpService.registrar("productos.php", { accion: "obtener_fotos" }),
      ]);
      this.producto = (prods || []).find((p) => p.id == id) || {};
      this.restaurante =
        (rests || []).find((r) => r.id == this.producto.restaurante_id) || {};
      this.fotosProducto = (fotos || [])
        .filter((f) => f.producto_id == id)
        .sort((a, b) => a.posicion - b.posicion);
      this.fotoPrincipal = this.fotosProducto[0]?.url || "";
      this.cargando = false;
    },
    async solicitarDatosSesion() {
      const actual = obtenerDatosSesion();
      if (actual?.telefono && actual?.nombre) return actual;

      const { value, isConfirmed } = await Swal.fire({
        title: "Datos para calificar",
        html: `
          <input id="numeroTelefono" class="swal2-input" placeholder="Número de teléfono" value="${
            actual?.telefono || ""
          }" />
          <input id="nombreCalificador" class="swal2-input" placeholder="Nombre de quien califica" value="${
            actual?.nombre || ""
          }" />
        `,
        focusConfirm: false,
        confirmButtonText: "Guardar y continuar",
        preConfirm: () => {
          const telefono = document
            .getElementById("numeroTelefono")
            .value.trim();
          const nombre = document
            .getElementById("nombreCalificador")
            .value.trim();

          if (!telefono || !nombre) {
            Swal.showValidationMessage("Completa todos los campos");
            return false;
          }

          return { telefono, nombre };
        },
      });

      if (!isConfirmed || !value) return null;
      return guardarDatosSesion(value);
    },
    async intentCalificar() {
      const datos = await this.solicitarDatosSesion();
      if (!datos) return;

      this.idUsuario = datos.telefono;
      this.nuevaCalificacion.idParticipante = datos.telefono;

      if (existeRegistroParaRestaurante(this.restaurante.id)) {
        this.existeCalificacion = true;
        this.mostrarCalificacion = true;
        this.$buefy.toast.open({
          message: "Ya registraste una calificación para este restaurante.",
          type: "is-warning",
        });
        return;
      }

      if (!this.existeCalificacion) {
        this.verificarCalificacion();
      }
      this.mostrarCalificacion = true;
    },

    async enviarCalificacion() {
      if (!this.nuevaCalificacion.calificacion) return;

      // Asegurar que estén asignados dentro del objeto calificacion
      this.nuevaCalificacion.idProducto = this.producto.id;
      this.nuevaCalificacion.idRestaurante = this.restaurante.id;

      const res = await HttpService.registrar("calificaciones.php", {
        accion: "registrar",
        calificacion: this.nuevaCalificacion,
      });

      if (res && res.ok) {
        this.existeCalificacion = true;
        registrarSesionEnTabla(this.restaurante.id);
        this.$buefy.toast.open({
          message: "Calificación guardada",
          type: "is-success",
        });
      } else {
        this.$buefy.toast.open({
          message: res.mensaje || "No se pudo guardar",
          type: "is-danger",
        });
      }
    },
    async verificarCalificacion() {
      const res = await HttpService.registrar("calificaciones.php", {
        accion: "obtener_usuario",
        idProducto: this.producto.id,
        idParticipante: this.idUsuario,
      });
      if (res && res.ok) {
        this.existeCalificacion = true;
        this.nuevaCalificacion.calificacion = res.calificacion;
        this.nuevaCalificacion.observaciones = res.observaciones;
        this.mostrarCalificacion = true; // 👈 Forzar que se muestre de una vez
      }
    },
    async obtenerColorEvento() {
      const res = await HttpService.registrar("eventos.php", {
        accion: "obtener",
      });

      // 👇 Aquí el fix importante
      if (Array.isArray(res) && res.length) {
        this.eventoColor = res[0].color_principal;
      }

      console.log("Color del evento:", this.eventoColor);
    },
    compartirProducto() {
      const url = window.location.href;
      if (navigator.share) {
        navigator
          .share({
            title: this.producto.nombre,
            text: `Mira este producto: ${this.producto.nombre}`,
            url: url,
          })
          .catch(console.error);
      } else {
        navigator.clipboard.writeText(url);
        this.$buefy.toast.open({
          message: "Enlace copiado al portapapeles",
          type: "is-success",
        });
      }
    },
  },
  computed: {
    estiloEvento() {
      return {
        backgroundColor: this.eventoColor,
        color: this.colorContraste(this.eventoColor),
      };
    },
    botonCalificarEstilo() {
      const base = this.restaurante.color_secundario || "#3273dc";
      return {
        backgroundColor: base,
        borderColor: base,
        color: this.colorContraste(base),
      };
    },
  },
};
</script>

<style scoped>
.zoom {
  transition: transform 0.3s ease;
  cursor: zoom-out;
  transform: scale(2.2); /* Ajusta el nivel de zoom */
}
.modal-imagen {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.95); /* Fondo más oscuro */
}

.modal-imagen img {
  max-width: 100%;
  max-height: 100vh;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.miniatura {
  width: 100%;
  max-height: 300px;
  object-fit: cover;
  cursor: zoom-in;
}

/* Fondo oscuro full-screen */
.zoom-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: black;
  z-index: 9999;
  display: flex;
  flex-direction: column;
}

/* Botón cerrar */
.cerrar {
  background: transparent;
  color: white;
  border: none;
  font-size: 2rem;
  text-align: right;
  padding: 1rem;
  align-self: flex-end;
  cursor: pointer;
}

/* Contenedor de imagen centrada */
.zoom-container {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;
}

/* Imagen con zoom y transiciones */
.zoom-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  transition: transform 0.2s ease;
  cursor: zoom-in;
}
.badge.restaurante-verificado {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  background-color: rgba(255, 255, 255, 0.15);
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
  backdrop-filter: blur(6px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
}

.icono-verificado {
  color: #2c73d2;
  font-size: 0.9rem;
}
.info-producto {
  min-height: 100vh;
}

@media screen and (max-width: 768px) {
  .foto-principal-container {
    max-height: 120vh;
  }
}

.carousel-item-foto {
  position: relative;
  width: 100%;
  height: 100%;
  aspect-ratio: 4 / 3;
}

.carousel-item-foto img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
}

/* ⭐ Calificación visual */
.star:hover {
  transform: scale(1.2);
  transition: 0.2s ease;
}

/* 📋 Lista de info */
.info {
  list-style: none;
  padding: 0;
}
.info li {
  margin-bottom: 0.5rem;
}

/* 🎯 Nuevos ítems estilo limpio */
.info-link {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 0.6rem;
  cursor: pointer;
}

.icono-info {
  color: #ff5f5f;
  font-size: 1rem;
}

.icono-info-Whatsapp {
  color: #60f06c;
  font-size: 1rem;
}

.texto-link {
  text-decoration: underline;
  text-decoration-style: dotted;
  text-underline-offset: 2px;
  color: inherit;
  font-weight: 500;
}

.texto-link:hover {
  text-decoration-style: solid;
  color: #2c73d2;
}

.flecha {
  font-size: 0.9rem;
  margin-left: auto;
  opacity: 0.6;
}

.sede-titulo {
  font-weight: bold;
  margin: 1rem 0 0.5rem;
}

/* 🌟 Estética caja calificación */
.box {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
}


.foto-principal-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}



/* — overlay-info — */
.overlay-info{
  position:absolute;
  bottom:16px;
  left:16px;
  color:#fff;
  z-index:2;

  display:flex;
  flex-direction:column;
  align-items:flex-start;
}

/* — ribbon — */
.nombre-wrapper{
  display:inline-block;
  background:rgba(0,0,0,.38);
  backdrop-filter:blur(6px);
  -webkit-backdrop-filter:blur(6px);
  border-radius:6px;
  padding:1px 5px;
  transition:background .25s ease,transform .25s ease;
}

.nombre-producto{
  font-size:clamp(.85rem,2.6vw,.95rem);
  font-weight:600;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
  margin:0;
}

/* hover en desktop */
.foto-principal-container:hover .nombre-wrapper{
  background:rgba(0,0,0,.55);
  transform:translateY(-2px);
}

/* mobile ribbon ancho completo */
@media (hover:none) and (pointer:coarse){
  .nombre-wrapper{
    width:100%;
    border-radius:0 0 8px 8px;
    padding:4px 8px;
    background:linear-gradient(to top,rgba(0,0,0,.55),rgba(0,0,0,0));
    transform:none!important;
  }
}


.badges {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.badge {
  background: rgba(255, 255, 255, 0.15);
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 0.75rem;
  backdrop-filter: blur(6px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
}

.badge.icono b-icon {
  font-size: 1rem;
}

.foto-principal-container {
  position: relative;
  height: 320px;
  overflow: hidden;
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
}
.badge.icono {
  cursor: pointer;
}

.boton-compartir {
  position: absolute;
  top: 12px;
  right: 12px;
  background-color: rgba(0, 0, 0, 0.6);
  border: none;
  border-radius: 50%;
  padding: 8px;
  color: white;
  z-index: 10;
}


.degradado {
  position: absolute;
  bottom: 0;
  height: 40%;
  width: 100%;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.85), transparent);
  z-index: 1;
}


.badges {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.badge {
  background: rgba(255, 255, 255, 0.15);
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 0.75rem;
  backdrop-filter: blur(6px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
}
.button.is-primary {
  background-color: #2c73d2 !important;
  border-color: #2c73d2 !important;
  color: white !important;
}

.badge.icono b-icon {
  font-size: 1rem;
}

.badge.icono b-icon,
.badge.icono b-icon > svg {
  color: white !important;
  fill: white !important;
  stroke: white !important;
}
.box.mt-5 {
  background-color: inherit; /* Usa el mismo fondo del evento */
  color: inherit;
  border: 1px solid rgba(255, 255, 255, 0.15); /* Borde tenue */
  padding: 1rem;
}

.box.mt-5 .b-field {
  margin-bottom: 1rem;
}

.box.mt-5 .b-input,
.box.mt-5 textarea {
  background-color: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  border-radius: 8px;
}

.box.mt-5 .b-input::placeholder,
.box.mt-5 textarea::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.box.mt-5 .b-input:focus,
.box.mt-5 textarea:focus {
  outline: none;
  border-color: #a3cff3;
  box-shadow: 0 0 0 2px rgba(163, 207, 243, 0.3);
}
</style>

